import { formatNumber } from './formatNumber';
export function currency(input, opts) {
    const defaultOptions = {
        symbol: '$',
        thousandsSeparator: ',',
        decimalPlaces: 2,
        ...opts,
    };
    return formatNumber(input, defaultOptions);
}
